import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const logoIsHiddenSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('hideLogo'),
)

export default logoIsHiddenSelector
